export default {
  container: 'flex flex-col',
  wrapper: 'flex flex-col sm:flex-row gap-[20px] sm:gap-[0] mt-[10px] rounded-xl',
  input: 'h-[50px] pl-[20px] pr-[5px] font-inter rounded-l-xl rounded-r-xl sm:rounded-r-none',
  button: 'h-[50px] px-[25px] bg-[#EC6D25] text-color-white font-inter rounded-r-xl rounded-l-xl sm:rounded-l-none hover:brightness-105 transition duration-300',
  messageWrapper: 'flex justify-center sm:justify-start gap-[20px] sm:gap-[0] mt-[10px]',
  sending: 'text-color-white',
  success: 'text-color-green',
  error: 'text-color-red',
};
